export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/components/circle-progressbar/CircleProgressBar.tsx"